export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '观众热评', href: '#comments' },
  { label: '关于我们', href: '#about' },
  { label: '常见问题', href: '#faq' },
  { label: '精选推荐', href: '#cards' },
  { label: '平台优势', href: '#features' },
  { label: '热播榜单', href: '#ranking' },
];

export const heroData = {
  tag: '每晚更新 · 追剧不等待',
  h1: '夜猫电影院',
  h1Suffix: '电视剧大全免费在线观看',
  slogan: '熬夜刷剧不卡顿，高清秒播零缓冲',
  description: '夜猫电影院专注于为剧迷打造极致的在线追剧体验。我们每日同步更新最新电视剧全集，覆盖古装、都市、悬疑、甜宠、海外等热门题材，所有剧集均支持高清画质与智能秒播技术。无论你是深夜独享还是周末连刷，这里都是你不可错过的追剧神器。',
  stats: [
    { value: '每日更新 30+', label: '新剧上线' },
    { value: '1080P', label: '高清画质' },
    { value: '秒级缓冲', label: '极速播放' },
  ],
  primaryCta: { label: '开始追剧', href: '#cards' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const indexItems = [
  {
    title: '热门推荐',
    icon: 'ri-fire-line',
    description: '全网热议剧集一网打尽，编辑精选口碑佳作',
    href: '#cards',
    accent: true,
  },
  {
    title: '最新上线',
    icon: 'ri-rocket-line',
    description: '每日同步更新，追新剧快人一步',
    href: '#updates',
  },
  {
    title: '古装剧场',
    icon: 'ri-building-2-line',
    description: '仙侠、宫斗、权谋，古风美学大赏',
    href: '#cards',
  },
  {
    title: '都市情感',
    icon: 'ri-heart-line',
    description: '职场爱情、家庭伦理，戳中你的心',
    href: '#cards',
  },
  {
    title: '悬疑推理',
    icon: 'ri-search-eye-line',
    description: '烧脑反转，每一帧都是线索',
    href: '#cards',
  },
  {
    title: '青春偶像',
    icon: 'ri-star-line',
    description: '甜宠校园、热血成长，青春不散场',
    href: '#cards',
  },
  {
    title: '海外精选',
    icon: 'ri-global-line',
    description: '韩剧、美剧、日剧，全球好剧汇聚',
    href: '#cards',
  },
];

export const mediaItems = [
  {
    title: '《长安夜未央》',
    subtitle: '古装悬疑巨制 · 全网独播',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20night%20with%20lanterns%20and%20silhouettes%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20warm%20tones%2C%20historical%20drama%20visual%20style%2C%20epic%20composition%2C%20moody%20and%20dramatic&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '热度榜 TOP1',
  },
  {
    title: '《城市恋人》',
    subtitle: '都市情感大剧 · 暖心回归',
    image: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20romantic%20urban%20atmosphere%2C%20two%20silhouettes%20on%20rooftop%2C%20cinematic%20photography%2C%20warm%20amber%20and%20rose%20tones%2C%20emotional%20drama%20aesthetic&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '口碑推荐',
  },
  {
    title: '《深渊游戏》',
    subtitle: '悬疑烧脑新作 · 限时抢先',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20urban%20alley%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20thriller%20atmosphere%2C%20cinematic%20noir%20style%2C%20deep%20shadows%20and%20dramatic%20contrast%2C%20suspenseful%20mood&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '新剧首发',
  },
];

export const appData = {
  title: '夜猫追剧 App',
  description: '随时随地畅享高清追剧体验，支持离线缓存、智能续播、弹幕互动，让追剧更自由。',
  features: ['离线缓存', '智能续播', '弹幕互动', '画质切换'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20Chinese%20TV%20drama%20streaming%20interface%20at%20night%2C%20warm%20dark%20background%20with%20soft%20glow%2C%20modern%20app%20UI%20design%2C%20cinematic%20lighting%2C%20cozy%20night%20viewing%20atmosphere&width=600&height=800&seq=app-entry-01&orientation=portrait',
};

export const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '1080P 高清画质',
    description: '全站剧集支持真高清播放，清晰细腻不模糊，每一帧都是视觉享受。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '智能秒播引擎',
    description: '独家加速技术，点击即播无需等待，拖动进度条瞬间响应。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库覆盖',
    description: '万部剧集持续扩充，古装都市悬疑甜宠一应俱全，追剧永不断档。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日同步更新',
    description: '新剧上线第一时间同步，追番不落后，热门剧集更新零时差。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    description: '专注观影体验，全程无弹窗无插播，让追剧回归纯粹享受。',
  },
];

export const rankingItems = [
  { rank: 1, title: '长安夜未央', category: '古装悬疑', heat: '9.8', trend: 'up', episodes: '更新至32集' },
  { rank: 2, title: '城市恋人', category: '都市情感', heat: '9.6', trend: 'up', episodes: '更新至28集' },
  { rank: 3, title: '深渊游戏', category: '悬疑推理', heat: '9.5', trend: 'up', episodes: '更新至16集' },
  { rank: 4, title: '星河长明', category: '青春偶像', heat: '9.3', trend: 'stable', episodes: '全40集' },
  { rank: 5, title: '破局者', category: '刑侦涉案', heat: '9.2', trend: 'up', episodes: '更新至24集' },
  { rank: 6, title: '风华录', category: '古装传奇', heat: '9.0', trend: 'stable', episodes: '全52集' },
  { rank: 7, title: '逆光飞行', category: '职场群像', heat: '8.9', trend: 'new', episodes: '更新至10集' },
];

export const faqItems = [
  {
    q: '夜猫电影院需要注册才能观看吗？',
    a: '不需要。夜猫电影院所有剧集均支持免注册免费在线观看，打开网站即可直接播放，无需任何账号登录。',
  },
  {
    q: '为什么有些剧集播放很流畅不卡顿？',
    a: '夜猫电影院采用智能秒播引擎和分布式加速节点，自动匹配最优线路，确保高清播放流畅不缓冲，即使深夜高峰期也能秒播。',
  },
  {
    q: '新剧上线后多久可以在这里看到？',
    a: '我们与各大平台保持同步更新节奏，热门新剧通常在首播后2小时内上线，确保追剧体验不落后于其他平台。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '完全支持。夜猫电影院已适配所有主流设备，手机、平板、电脑均可流畅观看，并支持画质自适应切换，节省流量。',
  },
];

export const contactData = {
  title: '剧集投稿与合作',
  description: '如果你有优质剧集资源推荐，或希望与我们展开内容合作，欢迎通过以下方式联系。我们珍视每一位剧迷的声音。',
  email: 'contact@yemaocinema.com',
};

export const topicItems = [
  { name: '长安夜未央', count: '128万讨论', hot: true },
  { name: '古装剧天花板', count: '96万讨论', hot: true },
  { name: '城市恋人结局', count: '83万讨论', hot: true },
  { name: '悬疑剧推荐', count: '75万讨论', hot: false },
  { name: '熬夜追剧党', count: '68万讨论', hot: false },
  { name: '新剧抢先看', count: '62万讨论', hot: true },
  { name: '甜宠剧安利', count: '55万讨论', hot: false },
  { name: '深渊游戏解析', count: '48万讨论', hot: true },
  { name: '演技炸裂名场面', count: '43万讨论', hot: false },
  { name: '周末连刷清单', count: '37万讨论', hot: false },
  { name: '高清片源分享', count: '31万讨论', hot: false },
];

export const updateItems = [
  { date: '08月01日', content: '《长安夜未央》第33-34集更新上线，剧情迎来重大反转', tag: '更新' },
  { date: '07月31日', content: '《城市恋人》第29-30集温情上线，男女主角关系出现转机', tag: '更新' },
  { date: '07月30日', content: '悬疑新作《深渊游戏》第17集限时抢先，烧脑程度再升级', tag: '抢先' },
  { date: '07月29日', content: '青春校园剧《星河长明》番外篇独家上线，圆满大结局后再续感动', tag: '独家' },
  { date: '07月28日', content: '《破局者》第25-26集更新，案件侦破进入关键阶段', tag: '更新' },
  { date: '07月27日', content: '夜猫电影院片库突破10万集，新增韩日美剧专区', tag: '公告' },
  { date: '07月26日', content: '播放引擎全面升级，1080P画质加载速度提升40%', tag: '公告' },
];

export const aboutData = {
  title: '关于夜猫电影院',
  description: '夜猫电影院诞生于深夜追剧的热爱。作为新一代电视剧在线观看平台，我们致力于为每一位剧迷提供最纯粹的观影体验——无需注册、无广告干扰、高清秒播。从古装巨制到都市小品，从悬疑烧脑到甜宠治愈，我们精心收录全网优质剧集，每日同步更新，让追剧成为一件简单而幸福的事。夜深人静时，有夜猫陪你。',
  stats: [
    { value: '10万+', label: '剧集总量' },
    { value: '500万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
  ],
};

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20young%20Chinese%20woman%2C%20warm%20lighting%2C%20natural%20portrait%2C%20soft%20background%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '追剧小达人',
    date: '3天前',
    content: '夜猫电影院真的太香了！《长安夜未央》更新速度超快，画质也清晰，晚上躺在被窝里追剧一点都不卡，已经安利给全宿舍了！',
    likes: 2389,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20Chinese%20man%20in%20his%20twenties%2C%20warm%20portrait%20lighting%2C%20clean%20background%2C%20natural%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '深夜影评人',
    date: '5天前',
    content: '作为一个悬疑剧重度爱好者，《深渊游戏》的播放体验让我惊喜。片源质量很高，而且没有烦人的弹窗广告，真正做到了纯净观影。',
    likes: 1856,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20young%20Chinese%20woman%20smiling%2C%20warm%20natural%20light%2C%20soft%20portrait%2C%20clean%20blurred%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '煲剧小能手',
    date: '1周前',
    content: '《城市恋人》大结局看哭了！感谢夜猫电影院让我第一时间追上更新，而且用手机看也很流畅，地铁通勤时间都用来追剧了哈哈～',
    likes: 4210,
  },
];

export const carouselItems = [
  {
    title: '长安夜未央',
    subtitle: '古装悬疑巅峰之作',
    description: '盛世长安暗流涌动，一桩离奇命案牵出惊天阴谋。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20at%20night%2C%20dramatic%20shadows%20from%20lanterns%2C%20mysterious%20atmosphere%2C%20historical%20drama%20aesthetic%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20cinematic%20lighting%2C%20epic%20composition&width=900&height=500&seq=carousel-01&orientation=landscape',
    tag: '热播中',
    tagColor: 'accent',
  },
  {
    title: '城市恋人',
    subtitle: '都市情感暖心大剧',
    description: '在城市森林里，每一次相遇都是久别重逢。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20cityscape%20at%20golden%20hour%2C%20warm%20ambient%20light%2C%20modern%20urban%20rooftop%20scene%2C%20soft%20bokeh%20background%2C%20emotional%20and%20cinematic%20mood%2C%20warm%20rose%20and%20amber%20tones&width=900&height=500&seq=carousel-02&orientation=landscape',
    tag: '口碑爆款',
    tagColor: 'primary',
  },
  {
    title: '深渊游戏',
    subtitle: '年度悬疑力作',
    description: '当真相沉入黑暗，只有最敏锐的眼睛才能看穿。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20street%20at%20night%20with%20reflective%20puddles%2C%20neon%20signs%20casting%20colored%20light%2C%20mysterious%20noir%20atmosphere%2C%20suspenseful%20thriller%20aesthetic%2C%20deep%20shadows%2C%20cinematic%20composition&width=900&height=500&seq=carousel-03&orientation=landscape',
    tag: '新剧首发',
    tagColor: 'secondary',
  },
  {
    title: '星河长明',
    subtitle: '青春校园治愈之作',
    description: '那些年我们一起追过的星空，藏着最美的秘密。',
    image: 'https://readdy.ai/api/search-image?query=Starry%20night%20sky%20above%20a%20peaceful%20campus%20scene%2C%20youthful%20and%20dreamy%20atmosphere%2C%20warm%20glowing%20lights%2C%20nostalgic%20cinematic%20mood%2C%20soft%20focus%2C%20romantic%20and%20hopeful%20tones&width=900&height=500&seq=carousel-04&orientation=landscape',
    tag: '全剧完结',
    tagColor: 'accent',
  },
];

export const cardItems = [
  {
    title: '长安夜未央',
    category: '古装悬疑',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ancient%20style%20scene%20with%20flowing%20silk%20fabrics%20and%20traditional%20architecture%2C%20warm%20golden%20lantern%20light%2C%20cinematic%20composition%2C%20dramatic%20shadows%2C%20historical%20drama%20atmosphere&width=600&height=360&seq=card-01&orientation=landscape',
    rating: '9.8',
    episodes: '更新至32集',
    tag: '热播',
  },
  {
    title: '城市恋人',
    category: '都市情感',
    image: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20romantic%20atmosphere%2C%20soft%20bokeh%2C%20urban%20lifestyle%20aesthetic%2C%20cinematic%20photography&width=600&height=360&seq=card-02&orientation=landscape',
    rating: '9.6',
    episodes: '更新至28集',
    tag: '热门',
  },
  {
    title: '深渊游戏',
    category: '悬疑推理',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20dramatic%20shaft%20of%20light%2C%20shadow%20patterns%2C%20suspenseful%20thriller%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20deep%20contrast&width=600&height=360&seq=card-03&orientation=landscape',
    rating: '9.5',
    episodes: '更新至16集',
    tag: '新剧',
  },
  {
    title: '破局者',
    category: '刑侦涉案',
    image: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20scene%20with%20evidence%20board%20and%20dim%20lighting%2C%20detective%20office%20atmosphere%2C%20warm%20desk%20lamp%20glow%2C%20cinematic%20composition%2C%20tense%20mood&width=600&height=360&seq=card-04&orientation=landscape',
    rating: '9.2',
    episodes: '更新至24集',
    tag: '推荐',
  },
  {
    title: '风华录',
    category: '古装传奇',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20landscape%20painting%20style%20scene%20with%20mountains%20and%20mist%2C%20elegant%20ancient%20aesthetic%2C%20warm%20earthy%20tones%2C%20poetic%20atmosphere%2C%20soft%20diffused%20light&width=600&height=360&seq=card-05&orientation=landscape',
    rating: '9.0',
    episodes: '全52集',
    tag: '经典',
  },
  {
    title: '逆光飞行',
    category: '职场群像',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20floor%20to%20ceiling%20windows%20and%20warm%20sunset%20light%20streaming%20in%2C%20professional%20atmosphere%2C%20cinematic%20composition%2C%20inspirational%20mood&width=600&height=360&seq=card-06&orientation=landscape',
    rating: '8.9',
    episodes: '更新至10集',
    tag: '新剧',
  },
  {
    title: '迷雾追踪',
    category: '悬疑犯罪',
    image: 'https://readdy.ai/api/search-image?query=Foggy%20forest%20path%20at%20dawn%20with%20mysterious%20atmosphere%2C%20soft%20diffused%20light%20through%20trees%2C%20cinematic%20suspense%20mood%2C%20cool%20and%20warm%20tone%20contrast&width=600&height=360&seq=card-07&orientation=landscape',
    rating: '8.7',
    episodes: '全24集',
    tag: '高分',
  },
];